import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LANGUAGES = [
  { code: 'es', name: 'ES', fullName: 'Español' },
  { code: 'en', name: 'EN', fullName: 'English' },
  { code: 'pt', name: 'PT', fullName: 'Português' }
];

export default function LanguageSelector({ className = '' }) {
  const { i18n } = useTranslation();

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div className={`relative inline-flex items-center ${className}`}>
      <Globe className="w-4 h-4 text-slate-400 mr-2" />
      <select
        value={i18n.language?.substring(0, 2) || 'es'}
        onChange={handleChange}
        className="bg-transparent border-none text-sm text-slate-300 cursor-pointer focus:outline-none appearance-none pr-6"
        data-testid="language-selector"
      >
        {LANGUAGES.map(lang => (
          <option key={lang.code} value={lang.code} className="bg-slate-800">
            {lang.name}
          </option>
        ))}
      </select>
      <div className="absolute right-0 pointer-events-none">
        <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
}
